/* eslint-disable no-shadow */
export default function install(Vue) {
  Object.defineProperties(Vue.prototype, {
    $modal: {
      get() {
        return {
          $show: (modalId) => {
            document.querySelector(`#${modalId}`).style = "display: block";
          },

          $hide: (modalId) => {
            document.querySelector(`#${modalId}`).style = "display: none";
          },
        };
      },
    },
  });
}
